// extracted by mini-css-extract-plugin
export default {"edit":"customChallenges_edit__ca2Sf","add":"customChallenges_add__Uoa-B"};